export default __webpack_public_path__ + "static/media/checklist.38779d26.png";